import { render, staticRenderFns } from "./SelectionList.vue?vue&type=template&id=249d06c4&scoped=true&"
import script from "./SelectionList.vue?vue&type=script&lang=js&"
export * from "./SelectionList.vue?vue&type=script&lang=js&"
import style0 from "./SelectionList.vue?vue&type=style&index=0&id=249d06c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d06c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249d06c4')) {
      api.createRecord('249d06c4', component.options)
    } else {
      api.reload('249d06c4', component.options)
    }
    module.hot.accept("./SelectionList.vue?vue&type=template&id=249d06c4&scoped=true&", function () {
      api.rerender('249d06c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/SelectionList.vue"
export default component.exports